import { Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import { convertDataToVisitors } from '../import_utils';
import { AppContext } from '@/AppContext';
import { MeetupContext } from '@/MeetupContext';
import { convertErrors } from './ValidationStep';
import ErrorBlock from 'components/ErrorBlock/ErrorBlock';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import Popover from '@mui/material/Popover';

const PREFIX = 'FinishStep';

const classes = {
  copied: `${PREFIX}-copied`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.copied}`]: {
    padding: theme.spacing(2),
  },
}));

export const FinishStep = props => {
  const { stepData, setError, error } = props;
  const data = stepData[0].data;
  const fields = stepData[1];
  const appContext = useContext(AppContext);
  const meetupContext = useContext(MeetupContext);
  const [result, setResult] = useState();

  // TODO: create dedicated component to show error logs
  const [copied, setCopied] = useState(false);
  const anchorEl = useRef();
  const { copy } = useCopyToClipboard();

  useEffect(() => {
    const [visitors, clientErrors] = convertDataToVisitors(data, fields, meetupContext);

    const importRequest = {
      onError: stepData[2].onError,
      onDuplicate: stepData[2].onDuplicate,
      visitors: visitors,
      dryRun: false,
    };

    appContext.visitorApi
      .importVisitors(meetupContext.meetupId, importRequest)
      .then(({ data: result }) => {
        const [errors, duplcates] = convertErrors(clientErrors, result.errors, visitors);

        setResult({
          addedCount: result.addedCount,
          updatedCount: result.updatedCount,
          skippedCount: result.skippedCount,

          errors: errors,
          duplicates: duplcates,
        });
      })
      .then(() => meetupContext.update())
      .catch(error => {
        console.log(error);
        setError(error.response.data.message);
      });
  }, [stepData]);

  if (error) {
    return null;
  }

  if (!result) {
    return (
      <StyledGrid container spacing={3}>
        <Grid
          size={{
            xs: 12,
            md: 12,
          }}
        >
          <Typography variant={'h3'}>Идёт загрузка ...</Typography>
        </Grid>
      </StyledGrid>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid
        data-cy={'visitors-import-result'}
        size={{
          xs: 12,
          md: 12,
        }}
      >
        <Typography variant={'h3'}>Результат</Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 12,
        }}
      >
        <Typography>Добавлено {result.addedCount} записей</Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 12,
        }}
      >
        <Typography>Обновлено {result.updatedCount} записей</Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 12,
        }}
      >
        <Typography>Пропущено {result.skippedCount} записей</Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 12,
        }}
      >
        <Typography>
          Ошибок: {result.errors.length}
          {result.errors.length > 0 && (
            <>
              &nbsp;(
              <Link
                color='primary'
                underline='always'
                style={{ cursor: 'pointer' }}
                ref={anchorEl}
                onClick={async () => {
                  const success = await copy(result.errors.join('\n'));
                  if (success) setCopied(true);
                }}
              >
                скопировать
              </Link>
              )
              {copied && (
                <Popover
                  open={true}
                  anchorEl={anchorEl.current}
                  onClose={() => setCopied(false)}
                  anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'center', horizontal: 'left' }}
                >
                  <Typography className={classes.copied}>Лог скопирован</Typography>
                </Popover>
              )}
            </>
          )}
        </Typography>
      </Grid>
    </Grid>
  );
};
